import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      networkMode: 'offlineFirst', // keep caches as long as possible
      refetchOnWindowFocus: false, // don’t refetch on window focus
      retry: false,
    },
  },
});
